import { useState, useCallback } from 'react';
import { useSuccessReactor } from '@livefree/reactive';
import { Button } from '@heroui/react';
import { useNavigate } from 'react-router';
import { useRecovery } from '@/features/login/forgot';
import { Countdown, Animate, StyledButton, CustomPin } from '@/shared/components';
import { RoutePaths } from '@/routing/RoutePaths';
import { reactive } from '@/core/reactive/reactive';

export const Verify = reactive.component(
  ({ services, monitors }) => {
    const [resend, setResend] = useState(false);
    const [message, setMessage] = useState('');
    const recovery = useRecovery();
    const navigate = useNavigate();

    useSuccessReactor(services.recovery.validateToken, payload => {
      if (payload.valid) {
        navigate(RoutePaths().login.resetPassword());
      } else {
        setMessage('Incorrect or expired code');
      }
    });

    const handleValidate = useCallback(() => {
      if (recovery.username && recovery.code) {
        services.recovery.validateToken(recovery.username, recovery.code);
      }
    }, [services, recovery.username, recovery.code]);

    return (
      <Animate id="verify" className="flex flex-col gap-4">
        <div className="text-small text-default-500">
          Enter the code sent to <strong>{recovery.email}</strong>.{' '}
        </div>
        <CustomPin
          length={6}
          onComplete={recovery.setCode}
          isInvalid={!!message}
          errorMessage="Incorrect code"
        />
        <Button
          color="primary"
          isLoading={monitors.validateToken.executing}
          isDisabled={!recovery.code}
          onPress={handleValidate}
        >
          Verify
        </Button>
        <Countdown
          from={60}
          text="Request new code"
          showCountdown={!resend}
          onExpire={() => setResend(true)}
        >
          <StyledButton
            size="sm"
            onClick={() => {
              setResend(false);
              setMessage('');
              services.recovery.requestToken(recovery.username);
            }}
          >
            Resend code
          </StyledButton>
        </Countdown>
      </Animate>
    );
  },
  {
    name: 'Verify',
    monitors: services => [services.recovery.validateToken],
  },
);
